/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TaskModel } from './TaskModel';
export type DocumentRequestView = {
  readonly id?: number;
  task: TaskModel;
  readonly created_at?: string;
  readonly updated_at?: string;
  name: string;
  slug?: string;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  delegator_email?: string | null;
  delegator_name?: string | null;
  notification_preference?: DocumentRequestView.notification_preference;
  folder?: number | null;
  parent_request?: number | null;
};
export namespace DocumentRequestView {
  export enum notification_preference {
    EACH_UPLOAD = 'each_upload',
    ALL_COMPLETE = 'all_complete',
    NONE = 'none',
  }
}

